import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ALERT_STYLES, SEVERITY_CLASS } from './AlertChip.constants';
import type { AlertChipProps } from './AlertChip.types';

export const AlertChip = ({ alert }: AlertChipProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'conversationDetail' });
	const known = ALERT_STYLES[alert];
	const Icon = known?.icon ?? CircleAlert;
	// Unknown alerts keep their raw identifier: a chip nobody styled still beats
	// a conversation whose warning was silently dropped.
	const label = known ? t(known.labelKey) : alert;

	return (
		<span
			className={`inline-flex items-center gap-3xs rounded-md border px-2xs py-3xs text-[11px] font-medium leading-none ${SEVERITY_CLASS[known?.severity ?? 'neutral']}`}
		>
			<Icon className="h-[12px] w-[12px] shrink-0" />
			{label}
		</span>
	);
};
